<template>
  <div>
    <div class="form__input">
      <label class="form__label">
        Malpractice Insurance File
      </label>
      <div class="custom-file-container">
        <b-form-file
          id="licenceFileUpload"
          :value="insurance.file"
          @change="handleEmit"
          name="licenceFileUpload"
          accept="image/*,application/pdf,application/msword"
          placeholder="Select an image, PDF, DOC, or DOCX file"
          drop-placeholder="Drop file here..."
          :state="Boolean(insurance.file)"
        />
        <font-awesome-icon
          :icon="['fa', 'file-upload']"
          class="icon alt"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'insurance',

  props:{
    value: {
      type: Object,
      required: false,
      default: () => ({
        file: null
      })
    }
  },
  data() {
    return {
      insurance: {
        file: null
      },
    }
  },
  watch: {
    value() {
      if(this.value)
        this.insurance = this.value;
      else if (!this.insurance)
        this.insurance = {
        file: null
      }
    }
  },
  async mounted() {
    if(this.value)
      this.insurance = this.value;
    else if (!this.insurance)
      this.insurance = {
        file: null
      }
  },
  computed: {
    isValid(){
      return !!this.insurance.file;
    }
  },
  methods:{
    handleEmit(event){
      const file = event.target.files[0];

      this.insurance.file = file; 
      
      if(!this.isValid)
        this.$emit('input', null)
      
      this.$emit('input', { ...this.insurance })
    }
  }
}
</script>

<style>

</style>